import * as Yup from 'yup';

export const addressModalValidationSchema = (requireRegion: boolean) => {
    if (requireRegion) {
        return Yup.object().shape({
            type: Yup.mixed().required('app.error.required'),
            usageType: Yup.mixed().required('app.error.required'),
            street: Yup.string().required('app.error.required'),
            zip: Yup.string().required('app.error.required'),
            city: Yup.string().required('app.error.required'),
            country: Yup.object().required('app.error.required').typeError('app.error.required'),
            region: Yup.mixed()
                .required('app.error.required')
                .test('not-empty', 'app.error.required', value => value !== null && value !== undefined),
        });
    }
    return Yup.object().shape({
        type: Yup.mixed().required('app.error.required'),
        usageType: Yup.mixed().required('app.error.required'),
        street: Yup.string().required('app.error.required'),
        zip: Yup.string().required('app.error.required'),
        city: Yup.string().required('app.error.required'),
        country: Yup.object().required('app.error.required').typeError('app.error.required'),
        region: Yup.mixed().nullable(),
    });
};
